module.exports = __webpack_public_path__ + "img/qiqiu2.55905fa2.png";